function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useCallback, useEffect, useRef } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { getElementPosition, getElementScroll, useScrollTo } from '@bydesign-ui/hooks';
export function TimeSelect(props) {
  var type = props.type,
      timeOptions = props.timeOptions,
      onSelect = props.onSelect,
      selectedIndex = props.selectedIndex;
  var listRef = useRef(null);
  var timeSelectCls = usePrefixCls("".concat(type, "-select"));
  var timeItemCls = usePrefixCls("".concat(type, "-select-item"));
  var timeItemActiveCls = usePrefixCls("".concat(type, "-select-item-active"));
  var timeItemDisabledCls = usePrefixCls("".concat(type, "-select-item-disabled"));
  var handleSelect = useCallback(function (value, disabled) {
    !disabled && onSelect(type, value);
  }, [onSelect]);

  var _useScrollTo = useScrollTo(listRef, 'top', function () {
    var container = listRef.current;

    if (!container) {
      return 0;
    }

    var activeELem = container.querySelector(".".concat(timeItemActiveCls));

    if (!activeELem) {
      return 0;
    }

    return getElementPosition(activeELem).top - getElementPosition(container).top + getElementScroll(container).scrollTop;
  }, 150, function () {
    return !!listRef.current;
  }),
      startScroll = _useScrollTo.startScroll;

  useEffect(function () {
    startScroll();
  }, [selectedIndex]);

  if (timeOptions.length === 0) {
    return null;
  }

  return React.createElement("div", {
    className: timeSelectCls,
    ref: listRef
  }, timeOptions.map(function (item, index) {
    var _classnames;

    var cls = classnames((_classnames = {}, _defineProperty(_classnames, timeItemCls, true), _defineProperty(_classnames, timeItemActiveCls, index === selectedIndex), _defineProperty(_classnames, timeItemDisabledCls, item.disabled), _classnames));
    return React.createElement("div", {
      key: item.value,
      className: cls,
      onClick: function onClick() {
        return handleSelect(item.value, item.disabled);
      }
    }, item.value);
  }));
}